module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "component"
  }, [_c('icon', {
    attrs: {
      "name": _vm.icon
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e46a5426"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/components/TableSortIndicator.vue
// module id = 1033
// module chunks = 0